module.exports = "/_next/static/images/card-virtual-03-f5075841eafc58f01540ea93abc5b70b.svg";